<template>
  <section>
    <div class="form-inline" style="margin-bottom:15px;">
      <span class=" btn btn-info pull-right" @click="clearAllCache()"> <i class="fa fa-trash"></i> ลบแคช</span>
      <datepicker :highlighted="highlighted" :bootstrapStyling="true" wrapper-class="form-group" language="th" v-on:selected="onDateSelectedSync('date', $event)" :value="syncFixturesParams.date" placeholder="DATE"></datepicker>
      <select v-model="syncFixturesParams.league_id" class="form-control">
        <option value=""> Leagues </option>
        <option v-for="(league,key) in options.leagues" :value="key">{{league}}</option>
      </select>
      <button type="button" class="btn btn-primary m-t-xs" :disabled="!syncFixturesParams.league_id || !syncFixturesParams.date" @click.prevent="syncFixture()">
        <i class="fa fa-refresh"></i> อัพเดตตารางแข่งขัน
      </button>
    </div>
    <div class="form-inline" style="margin-bottom:15px;">
      <datepicker :highlighted="highlighted" :bootstrapStyling="true" wrapper-class="form-group" language="th" v-on:selected="onDateSelected('from', $event)" :value="moreParams.from" placeholder="FROM"></datepicker>
      <datepicker :highlighted="highlighted" :bootstrapStyling="true" wrapper-class="form-group" language="th" v-on:selected="onDateSelected('to', $event)" :value="moreParams.to" placeholder="TO">
      </datepicker>
      <select v-model="moreParams.league_id" class="form-control" v-on:change.prevent="onChangeFilters()">
        <option value=""> Leagues </option>
        <option v-for="(league,key) in options.leagues" :value="key">{{league}}</option>
      </select>
      <select v-model="moreParams.ref_status" class="form-control" v-on:change.prevent="onChangeFilters()">
        <option value=""> Match Status </option>
        <option v-for="(refStatus,key) in options.match_status" :value="key">{{refStatus}}</option>
      </select>
      <select v-model="moreParams.status" class="form-control" v-on:change.prevent="onChangeFilters()">
        <option value=""> Status </option>
        <option v-for="(status,key) in options.status" :value="key">{{status}}</option>
      </select>
      <select v-model="moreParams.status_payment" class="form-control" v-on:change.prevent="onChangeFilters()">
        <option value=""> Payment Status </option>
        <option v-for="(status,key) in options.status_payment" :value="key">{{status}}</option>
      </select>
      <span class="btn btn-info m-t-xs" @click="onResetFilter()"> Reset</span>
      <div class="abnormal">
        <label class="k-checks">
          <input type="checkbox" v-model="moreParams.abnormal" true-value="true" false-value="" v-on:change.prevent="onChangeFilters()"/> ตรวจสอบสถานะผิดปกติ</label>
      </div>
    </div>
    <div class="table-responsive table-scrollable table-member-transaction vuetable space-loader" v-bind:class="{ loading: loading }">
      <table class="table table-bordered">
        <thead>
        <tr>
          <td class="text-center" width="5%"><strong>#</strong></td>
          <td class="text-center" width="5%"><strong>Starting Time</strong></td>
          <td class="text-center" width="5%"><strong>Match Status</strong></td>
          <td class="text-center" width="15%"><strong>Home</strong></td>
          <td class="text-center" width="5%"><strong>Score</strong></td>
          <td class="text-center" width="15%"><strong>Away</strong></td>
          <td class="text-center" width="5%"><strong>FT</strong></td>
          <td class="text-center" width="5%"><strong>HT</strong></td>
          <template v-if="!isOtherMonitor">
            <td class="text-center">Status</td>
            <td class="text-center">รายการแทง</td>
            <td class="text-center">สถานะออกผล</td>
            <td class="text-center" width="10%">แก้ไขล่าสุด</td>
            <td class="text-center" width="10%">
              <span class=" btn  btn-xs text-white" :class="timeSync<4?'btn-warning':'btn-info'" @click="reload()"> ( {{ timeSync}} ) Reload</span>
            </td>
          </template>
          <template v-if="isOtherMonitor">
            <td class="text-center">Vdo</td>
          </template>
        </tr>
        </thead>
        <template v-for="(fixtures,key) in groupFixtures">
          <thead>
          <tr>
            <th colspan="13" class="text-left">
              <strong> {{ get(groupFixtures, key + '.[0].meta.league_name') }}</strong>
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(fixture,index) in groupFixtures[key]" :class="[fixture.active===1?'':'c-unactive']">
            <td>
              <div class="number-in-league">{{ index + 1}}</div>
              <br/>
              <small class="fixture-ref">
                <div>Ref : {{ fixture.ref_id }}</div>
                <div>Event : {{ fixture.ref_event_id }}</div>
              </small>
            </td>
            <td>
              <small>
                {{ getMoment(fixture.local_starting_at, 'MMM') }} {{ getMoment(fixture.local_starting_at, 'YYYY') }}<br/>
                {{ getMoment(fixture.local_starting_at, 'DD') }} {{ getMoment(fixture.local_starting_at, 'dddd HH:mm') }}
              </small>
            </td>
            <td>
              <span class="text-info" v-html="getMatchStatus(fixture)" @click="setToggleEditScore(fixture,'ref_status')"></span>
              <div class="form-inline form-edit-able" v-show="getEditScore(fixture,'ref_status')">
                <select class="form-control ref_status">
                  <option value=""> Match Status </option>
                  <option v-for="(refStatus,key) in options.match_status" :value="key">{{refStatus}}</option>
                </select>
                <br/>
                <span style="margin-top:5px;" class="btn btn-sm btn-primary" @click="setRefStatusByInput($event,fixture)">Save</span>
                <span style="margin-top:5px;" class="btn btn-sm btn-default" @click="setToggleEditScore(fixture,'ref_status')">Cancel</span>
              </div>

            </td>
            <td>
              <span>{{ get(fixture, 'meta.localteam.name') }}</span>
              <span class="pull-left" v-html="getTeamIcon(get(fixture,'meta.localteam.logo_path'))"></span>
            </td>
            <td>
              <span>{{ scoreDisplayScore(fixture) }}</span>
            </td>
            <td>
              <span>{{ get(fixture, 'meta.visitorteam.name') }}</span>
              <span class="pull-right" v-html="getTeamIcon(get(fixture,'meta.visitorteam.logo_path'))"></span>
            </td>
            <td>
              <div @click="setToggleEditScore(fixture,'ft_score')">{{ scoreDisplay(fixture) ? fixture.ft_score ? fixture.ft_score : '?-?' : '?-?' }}</div>
              <div class="form-inline form-score" v-show="getEditScore(fixture,'ft_score')">
                <input type="number" style="width:60px" class="form-control home_score" min="0"/>
                <input type="number" style="width:60px" class="form-control away_score" min="0"/>
                <br/>
                <span style="margin-top:5px;" class="btn btn-sm btn-primary" @click="updateFixtureById(fixture.id,{ft_score:setScoreByInput($event)})">Save</span>
                <span style="margin-top:5px;" class="btn btn-sm btn-default" @click="setToggleEditScore(fixture,'ft_score')">Cancel</span>
              </div>
            </td>
            <td>
              <div @click="setToggleEditScore(fixture,'ht_score')">{{ scoreDisplay(fixture) ? fixture.ht_score ? fixture.ht_score : '?-?' : '?-?' }}</div>
              <div class="form-inline form-score" v-show="getEditScore(fixture,'ht_score')">
                <input type="number" style="width:60px" class="form-control home_score" min="0"/>
                <input type="number" style="width:60px" class="form-control away_score" min="0"/>
                <br/>
                <span style="margin-top:5px;" class="btn btn-sm btn-primary" @click="updateFixtureById(fixture.id,{ht_score:setScoreByInput($event)})">Save</span>
                <span style="margin-top:5px;" class="btn btn-sm btn-default" @click="setToggleEditScore(fixture,'ht_score')">Cancel</span>
              </div>
            </td>
            <template v-if="!isOtherMonitor">
              <td>
                <span>{{ fixture.status }}</span>
              </td>
              <td>
                <a :href="'/admin/stakes/sport/soccer?fixture_id='+fixture.id">
                  <span>{{ fixture.betSlip.total }}/{{ fixture.betSlip.complete }}</span>
                </a>
              </td>
              <td>
                <span class="label label-info" v-if="fixture.payment_at">จ่ายเงินแล้ว</span>
                <span class="label label-danger" v-if="fixture.refund_at">คืนเงินแล้ว</span>
                <br v-if="fixture.payment_at && fixture.refund_at"/>
                <span class="label label-default" v-if="! fixture.payment_at && ! fixture.refund_at && (fixture.ref_status ==='NS' || fixture.ref_status ==='LIVE' || fixture.ref_status ==='HT' )">รอจบเกมส์</span>
                <span class="label label-warning" v-if="! fixture.payment_at && ! fixture.refund_at && fixture.ref_status ==='FT' && ! fixture.is_result">รอออกผล</span>
                <span class="label label-warning" v-if="! fixture.payment_at && ! fixture.refund_at && fixture.ref_status ==='FT' && fixture.is_result ">รอจ่ายเงิน</span>
                <br/>
                <br/>
                <small>เดิมพันทั้งหมด : <span>{{ get(fixture, 'sumBet[0].sum_bet', 0) | number }}</span></small>
                <br/>
                <small>ได้เสียทั้งหมด : <span :class="getClassMoney(get(fixture,'sumBet[0].sum_result',0))">{{ get(fixture, 'sumBet[0].sum_result', 0) | number }}</span>
                </small>
              </td>
              <td>
                <span>{{ fixture.updated_at }}</span><br/>
                <span v-show="fixture.not_sync" class="label label-danger">ปิดการ Sync</span>
              </td>
              <td>
                {{ getLabelResult() }} {{ getBtnActionS() }}
                <div class="btn-fixture-odds">
                  <a :href="'/admin/spt/soccer/odds/pre_odds/'+fixture.id+getAllQueryParamsSerialize()" class="btn btn-xs" :class="getBtnPreMatchOdds(fixture)"><span class="pull-left">Pre Match</span><span class="pull-right">{{ fixture.pre_match }}/{{ fixture.pre_match_active }}</span></a>
                </div>
                <div class="btn-fixture-odds">
                  <a :href="'/admin/spt/soccer/odds/in_play_odds/'+fixture.id+getAllQueryParamsSerialize()" class="btn btn-xs" :class="getBtnInPlayOdds(fixture)"><span class="pull-left">In Play</span><span class="pull-right">{{ fixture.in_play }}/{{ fixture.in_play_active }}</span></a>
                </div>
                <div class="btn-group pull-right">
                  <button data-toggle="dropdown" class="btn btn-default btn-xs dropdown-toggle">
                    <i class="fa fa-cog"></i>
                    <span class="caret"></span>
                  </button>
                  <ul class="dropdown-menu pull-right">
                    <li>
                      <a href="javascript:void(0)" @click="syncFixtureById(fixture.id)"><i class="fa fa-refresh"></i> Sync Fixture</a>
                    </li>
                    <li class="divider"></li>
                    <li>
                      <a href="javascript:void(0)" @click="updateFixtureById(fixture.id,{not_sync:getToggleStatus(fixture.not_sync)})"><i class="fa fa-refresh" :class="getToggleStatus(fixture.not_sync)?'text-danger':'text-info'"></i> {{getToggleStatus(fixture.not_sync) ? 'Sync Off' : 'Sync On'}}</a>
                    </li>
                    <li class="divider"></li>
                    <li>
                      <a href="javascript:void(0)"><i class="fa fa-pencil"></i> แก้ไข</a>
                    </li>
                  </ul>
                </div>
                <div class="switch pull-left">
                  <div class="onoffswitch">
                    <input type="checkbox" name="collapsemenu" v-model="fixture.active" class="onoffswitch-checkbox" :id="'collapsemenu-'+fixture.id" @change.prevent="setActive(fixture,$event)">
                    <label class="onoffswitch-label" :for="'collapsemenu-'+fixture.id">
                      <span class="onoffswitch-inner"></span>
                      <span class="onoffswitch-switch"></span>
                    </label>
                  </div>
                </div>
              </td>
            </template>
            <template v-if="isOtherMonitor">
              <td>
                <div class="text-right">{{ fixture.vdo_url }} <span class="btn btn-sm btn-info" @click="setToggleEditScore(fixture,'vdo_url')"><i class="fa fa-pencil"></i> แก้ไข</span>
                </div>
                <div class="form-inline form-vdo text-right" v-show="getEditScore(fixture,'vdo_url')">
                  <div>
                    <input type="text" class="form-control edit-vdo" style="width: 100%"/>
                  </div>
                  <div>
                    <span style="margin-top:5px;" class="btn btn-sm btn-primary" @click="updateVdoFixtureById(fixture.id,{vdo_url:setVdoByInput($event)})">Save</span>
                    <span style="margin-top:5px;" class="btn btn-sm btn-default" @click="setToggleEditScore(fixture,'vdo_url')">Cancel</span>
                  </div>
                </div>
              </td>
            </template>
          </tr>
          </tbody>
        </template>
      </table>
    </div>

    <div class="vuetable-pagination clearfix text-right">
      <div class="pull-left" v-if="get(tablePagination,'to')">
        Displaying {{tablePagination.from}} to {{ tablePagination.to }} of {{tablePagination.total}} items
      </div>
      <div class="pull-right">
        <template>
          <ul class="pagination">
            <li :class="{'disabled': isOnFirstPage}">
              <a href="" @click.prevent="loadPage('prev')">
                <span>&laquo;</span>
              </a>
            </li>
            <template v-if="notEnoughPages">
              <li v-for="n in totalPage" :class="{'active': isCurrentPage(n)}" :key="n">
                <a @click.prevent="loadPage(n)" v-html="n"></a>
              </li>
            </template>
            <template v-else>
              <li v-for="n in windowSize" :class="{'active': isCurrentPage(windowStart+n-1)}" :key="n">
                <a @click.prevent="loadPage(windowStart+n-1)" v-html="windowStart+n-1"></a>
              </li>
            </template>
            <li :class="{'disabled': isOnLastPage}">
              <a href="" @click.prevent="loadPage('next')">
                <span>&raquo;</span>
              </a>
            </li>
          </ul>
        </template>
      </div>
    </div>
  </section>
</template>
<script>
  import {
    getMoment,
    scoreDisplayScore,
    scoreDisplay,
    paymentClass,
    getLogs,
    setSortHDA,
    getMatchStatus,
    getTeamIcon
  } from './helpers'
  import Datepicker from 'vuejs-datepicker'

  export default {
    name: 'sport-soccer-fixture',
    components: {
      Datepicker,
    },
    props: {
      isOtherMonitor: {
        type: Boolean,
        default() {
          return false
        }
      },
      onEachSide: {
        type: Number,
        default() {
          return 2
        }
      },
      queryParams: {
        type: Object,
        default() {
          return {
            sort: 'sort',
            page: 'page',
            perPage: 'per_page'
          }
        }
      },
      httpMethod: {
        type: String,
        default: 'get',
        validator: (value) => {
          return ['get', 'post'].indexOf(value) > -1
        }
      },
      moreParamsX: {
        type: Object,
        default() {
          return {
            from: moment().format('YYYY-MM-DD'),
            to: moment().format('YYYY-MM-DD'),
            ref_status: '',
            status: '',
            league_id: '',
            match_status: '',
            status_payment: '',
            abnormal: ''
          }
        }
      },
      currentPageX: {
        type: Number,
        default() {
          return 1
        }
      },
    },
    data() {
      return {
        highlighted: {
          dates: [ // Highlight an array of dates
            new Date(),
          ],
          // a custom function that returns true of the date is highlighted
          // this can be used for wiring you own logic to highlight a date if none
          // of the above conditions serve your purpose
          // this function should accept a date and return true if is highlighted
          includeDisabled: true // Highlight disabled dates
        },
        apiUrl: 'spt/soccer',
        fixtures: {},
        syncFixturesParams: {
          league_id: '',
          date: moment().format('YYYY-MM-DD')
        },
        groupFixtures: {},
        tablePagination: null,
        tempScore: {},
        loading: false,
        options: {
          status: {},
          match_status: {},
          leagues: {},
          status_payment: {}
        },
        appendParams: {
          per_page: 100
        },
        moreParams: this.moreParamsX,
        currentPage: this.currentPageX,
        httpOptions: {
          headers: {
            'X-CSRF-TOKEN': window.App.csrfToken,
            'X-Requested-With': 'XMLHttpRequest',
            'Authorization': 'Bearer ' + window.App.jwtToken
          }
        },
        tempEdit: {
          ht_score: {},
          ft_score: {},
          ref_status: {},
          vdo_url: {}
        },
        timeSync: 45,
        baseTimeSync: 45,
      }
    },
    computed: {
      //pagination
      totalPage() {
        return this.tablePagination === null
          ? 0
          : this.tablePagination.last_page
      },
      isOnFirstPage() {
        return this.tablePagination === null
          ? false
          : this.tablePagination.current_page === 1
      },
      isOnLastPage() {
        return this.tablePagination === null
          ? false
          : this.tablePagination.current_page === this.tablePagination.last_page
      },
      notEnoughPages() {
        return this.totalPage < (this.onEachSide * 2) + 4
      },
      windowSize() {
        return this.onEachSide * 2 + 1;
      },
      windowStart() {
        if (!this.tablePagination || this.tablePagination.current_page <= this.onEachSide) {
          return 1
        } else if (this.tablePagination.current_page >= (this.totalPage - this.onEachSide)) {
          return this.totalPage - this.onEachSide * 2
        }
        return this.tablePagination.current_page - this.onEachSide
      },
    },
    mounted() {
      this.appendParams = _.assign(this.appendParams, this.moreParams)
      this.loadData()
      this.getDataInterVal()
    },
    methods: {
      get(data, key, df = null) {
        return _.get(data, key, df)
      },
      getMoment: function (value, format = 'HH:mm', local = 'th') {
        return getMoment(value, format, local)
      },
      getDataInterVal() {
        setInterval(function () {
          this.timeSync--
          if (this.timeSync === 0) {
            this.loadData(this.loadSuccess, this.loadFailed, false)
            this.timeSync = _.cloneDeep(this.baseTimeSync)
          }
        }.bind(this), 1000)
      },

      // load data
      reload(timeOut = 0, preloading = true) {
        this.timeSync = timeOut ? timeOut : _.cloneDeep(this.baseTimeSync)
        if (!timeOut) {
          this.loadData(this.loadSuccess, this.loadFailed, preloading)
          history.pushState(null, '', '/admin/' + this.apiUrl + '/' + this.getAllQueryParamsSerialize());
        }
      },
      updateFixtureById(id, params) {
        if (_.has(params, 'not_sync') || _.has(params, 'ref_status')) {
          swal({
              title: "ยืนยันการอัพเดต",
              type: "warning",
              showCancelButton: true,
              confirmButtonColor: "#1ab394",
              confirmButtonText: "ยืนยัน",
              cancelButtonText: "ปิด",
              closeOnConfirm: true
            },
            function () {
              this.updateData(id, params)
            }.bind(this));
        } else {
          this.updateData(id, params)
        }
      },
      updateVdoFixtureById(id, params) {
        swal({
            title: "ยืนยันการอัพเดต",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#1ab394",
            confirmButtonText: "ยืนยัน",
            cancelButtonText: "ปิด",
            closeOnConfirm: true
          },
          function () {
            axios.put(`${this.apiUrl}/${id}/vdo`, params).then(response => {
              if (response.data) {

                const data = response.data
                if (_.has(params, 'vdo_url')) {
                  this.setToggleEditScore(data, 'vdo_url')
                }

                const currentData = _.find(this.groupFixtures[data.league_id], ['id', id])
                currentData.active = data.active
                currentData.not_sync = data.not_sync
                currentData.ft_score = data.ft_score
                currentData.ref_status = data.ref_status
                currentData.ht_score = data.ht_score
                currentData.updated_at = data.updated_at
                currentData.vdo_url = data.vdo_url

                this.$message.success({
                  showClose: true,
                  message: `อัพเดตข้อมูลเรียบร้อย`,
                  duration: 2000
                })
              }

            })
              .catch(err => {
                this.$message.error({
                  showClose: true,
                  message: 'เกิดข้อผิดพลาด' + _.get(err, 'response.data[0].message', ''),
                  duration: 5000
                })
              })
          }.bind(this))
      },
      setActive(fixture, e) {
        const status = e.target.checked
        this.updateFixtureById(fixture.id, {active: status})
      },
      updateData(id, params) {
        axios.put(`${this.apiUrl}/${id}`, params).then(response => {
          if (response.data) {

            const data = response.data
            if (_.has(params, 'ht_score')) {
              this.setToggleEditScore(data, 'ht_score')
            }
            if (_.has(params, 'ft_score')) {
              this.setToggleEditScore(data, 'ft_score')
            }
            if (_.has(params, 'ref_status')) {
              this.setToggleEditScore(data, 'ref_status')
            }

            const currentData = _.find(this.groupFixtures[data.league_id], ['id', id])
            currentData.active = data.active
            currentData.not_sync = data.not_sync
            currentData.ft_score = data.ft_score
            currentData.ref_status = data.ref_status
            currentData.ht_score = data.ht_score
            currentData.updated_at = data.updated_at

            this.$message.success({
              showClose: true,
              message: `อัพเดตข้อมูลเรียบร้อย`,
              duration: 2000
            })
          }

        })
          .catch(err => {
            this.$message.error({
              showClose: true,
              message: 'เกิดข้อผิดพลาด' + _.get(err, 'response.data[0].message', ''),
              duration: 5000
            })
          })
      },
      clearAllCache() {
        axios.post(`${this.apiUrl}/clear_cache_all`).then(response => {

          this.$message.success({
            showClose: true,
            message: 'ลบแคชเรียบร้อย',
            duration: 2000
          })
        })
          .catch(err => {
            this.$message.error({
              showClose: true,
              message: 'เกิดข้อผิดพลาด' + _.get(err, 'response.data[0].message', ''),
              duration: 2000
            })
          })

      },
      syncFixture() {
        axios.post(this.apiUrl, this.syncFixturesParams)
          .then(response => {
            this.reload(6)
            this.$message.success({
              showClose: true,
              message: 'อัพเดตรารางแข่งขันเรียบร้อย',
              duration: 2000
            })
          })
          .catch(err => {
            this.$message.error({
              showClose: true,
              message: 'เกิดข้อผิดพลาด' + _.get(err, 'response.data[0].message', ''),
              duration: 2000
            })
          })
      },
      syncFixtureById(id) {
        axios.post(`${this.apiUrl}/${id}/sync`, this.syncFixturesParams)
          .then(response => {
            this.reload(6)
            this.$message.success({
              showClose: true,
              message: 'อัพเดตรารางแข่งขันเรียบร้อย',
              duration: 2000
            })

          })
          .catch(err => {
            this.$message.error({
              showClose: true,
              message: 'เกิดข้อผิดพลาด',
              duration: 2000
            })
          })
      },
      syncOddsById(id, type) {
        axios.post(`${this.apiUrl}/${id}/sync_odds`, {type: type})
          .then(response => {
            this.reload(6)

            this.$message.success({
              showClose: true,
              message: `อัพเดต ${_.replace(type, '_', '')} Odds เรียบร้อย`,
              duration: 2000
            })
          })
          .catch(err => {
            this.$message.error({
              showClose: true,
              message: 'เกิดข้อผิดพลาด' + _.get(err, 'response.data[0].message', ''),
              duration: 2000
            })
          })
      },

      loadData(success = this.loadSuccess, failed = this.loadFailed, preloading = true) {
        if (preloading)
          this.onLoading()

        this.httpOptions['params'] = this.getAllQueryParams()
        return this.fetch(this.apiUrl, this.httpOptions).then(
          success,
          failed
        ).catch(() => failed())
      },
      fetch(apiUrl, httpOptions) {
        return this.httpFetch
          ? this.httpFetch(apiUrl, httpOptions)
          : axios[this.httpMethod](apiUrl, httpOptions)
      },
      loadSuccess(response) {
        this.options = response.data.options
        this.setPaginationData(response.data.fixtures.links.pagination)
        this.fixtures = response.data.fixtures.data
        for (let group  in  response.data.groupFixtures) {
          for (let fixture in response.data.groupFixtures[group]) {
            let data = _.find(_.get(this.groupFixtures, group, null), ['id', _.get(response.data.groupFixtures[group][fixture], 'id')])
            if (data === undefined || !data.hasOwnProperty('tempEdit')) {
              Object.assign(response.data.groupFixtures[group][fixture], {
                tempEdit: {
                  ht_score: false,
                  ft_score: false,
                  ref_status: false,
                  vdo_url: false,
                }
              })
            } else {
              Object.assign(response.data.groupFixtures[group][fixture], {
                tempEdit: _.get(data, 'tempEdit')
              })
            }
          }
        }
        this.groupFixtures = response.data.groupFixtures

        this.onLoaded()
      },
      loadFailed(response) {
        this.onLoaded()
        console.error('load-error', response)
      },
      setEditFixture() {

      },
      // other function
      getAllQueryParams() {
        let params = {}
        params[this.queryParams.page] = this.currentPage
        params[this.queryParams.perPage] = this.perPage
        for (let x in this.appendParams) {
          params[x] = this.appendParams[x]
        }
        return params
      },
      getAllQueryParamsSerialize() {
        let obj = this.getAllQueryParams()
        var str = [];
        for (var p in obj)
          if (obj.hasOwnProperty(p)) {
            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
          }
        return '?' + str.join("&");
      },
      getToggleStatus(status) {
        if (status === 1) {
          return 0
        }
        return 1
      },
      getBtnPreMatchOdds(fixture) {
        let classBtn = 'btn-danger'
        if (fixture.pre_match) {
          classBtn = 'btn-info'
          if (!fixture.pre_match_active) {
            classBtn = 'btn-warning'
          }

        }
        return classBtn
      },
      getBtnInPlayOdds(fixture) {
        let classBtn = 'btn-danger'
        if (fixture.in_play) {
          classBtn = 'btn-info'
          if (!fixture.in_play_active) {
            classBtn = 'btn-warning'
          }
        }

        return classBtn
      },
      getLabelResult() {
      },
      getBtnActionS() {
      },
      getInPlayScore(record) {
        return record.inplay_score ? record.inplay_score : '?-?'
      },
      getMatchStatus(fixture) {
        return getMatchStatus(fixture)
      },
      getTeamIcon(logoPath) {
        return getTeamIcon(logoPath)
      },
      paymentClass(record) {
        return paymentClass(record)
      },
      toFloat(value, fixed = 2) {
        return parseFloat(value).toFixed(fixed)
      },
      scoreDisplay(fixture) {
        return scoreDisplay(fixture)
      },
      scoreDisplayScore(fixture) {
        return scoreDisplayScore(fixture)
      },
      setToggleEditScore(fixture, action) {

        let data = _.find(this.groupFixtures[fixture.league_id], ['id', fixture.id])
        if (_.get(data, `tempEdit.${action}`, false)) {
          data.tempEdit[`${action}`] = false

          return false
        }
        data.tempEdit[`${action}`] = true
        return true
      },
      getEditScore(fixture, action) {
        let data = _.find(this.groupFixtures[fixture.league_id], ['id', fixture.id])
        return _.get(data, `tempEdit.${action}`, false)
      },
      setScoreByInput(event) {
        const home = $(event.target).closest('.form-score').find('.home_score').val()
        const away = $(event.target).closest('.form-score').find('.away_score').val()
        if (_.trim(home) >= 0 && _.trim(away) >= 0) {
          return `${home}-${away}`
        }
        return null
      },
      setVdoByInput(event) {
        const vdo = $(event.target).closest('.form-vdo').find('.edit-vdo').val()
        return vdo
      },
      setRefStatusByInput(event, fixture) {
        const refStatus = $(event.target).closest('.form-edit-able').find('.ref_status').val()
        if (!refStatus) {
          this.$message.error({
            showClose: true,
            message: `กรุณาระบุ Match Status`,
            duration: 2000
          })
          event.preventDefault()
          return false
        }
        this.updateFixtureById(fixture.id, {ref_status: refStatus})
      },

      setEditHtScore() {

      },
      getEditHtScore() {

      },
      setCancelEditFtScore() {

      },
      setCancelEditHtScore() {

      },
      setSaveEditHtScore() {

      },
      setSaveEditFtScore() {

      },
      onResetFilter() {
        this.moreParams = _.cloneDeep({
          from: '',
          to: '',
          ref_status: '',
          status: '',
          league_id: '',
          match_status: '',
          status_payment: '',
          abnormal: ''
        })
        this.currentPage = 1
        this.onChangeFilters()
      },
      onChangeFilters() {
        this.appendParams = _.assign(this.appendParams, this.moreParams)
        this.reload()
      },
      onDateSelected(v, d) {
        const date = moment(d).format('YYYY-MM-DD')
        this.moreParams[v] = date
        this.onChangeFilters()
      },
      onDateSelectedSync(v, d) {
        const date = moment(d).format('YYYY-MM-DD')
        this.syncFixturesParams[v] = date
      },
      onRowClicked(data, field, event) {
        //
      },
      onLoading() {
        this.loading = true
      },
      onLoaded() {
        this.loading = false
      },
      // pagination action
      isCurrentPage(page) {
        return page === this.tablePagination.current_page
      },
      setPaginationData(tablePagination) {
        this.tablePagination = tablePagination
      },
      changePage(page) {
        if (page === 'prev') {
          this.gotoPreviousPage()
        } else if (page === 'next') {
          this.gotoNextPage()
        } else {
          this.gotoPage(page)
        }
      },
      gotoPreviousPage() {
        if (this.currentPage > 1) {
          this.currentPage--
          this.reload()
        }
      },
      gotoNextPage() {
        if (this.currentPage < this.tablePagination.last_page) {
          this.currentPage++
          this.reload()
        }
      },
      gotoPage(page) {
        if (page != this.currentPage && (page > 0 && page <= this.tablePagination.last_page)) {
          this.currentPage = page
          this.reload()
        }
      },
      resetData() {
        this.tablePagination = null
      },
      loadPage(page) {
        this.changePage(page)
      },
      getClassMoney(value) {
        if (value === 0) {
          return ''
        }
        if (value > 0) {
          return 'text-positive'
        }
        return 'text-negative'

      }

    }
  }
</script>
<style>
  /*.table tbody tr {*/
  /*cursor: pointer;*/
  /*}*/

  .table tbody td {
    text-align: center;
  }

  .btn-fixture-odds a {
    min-width: 120px;
  }

  .k-checks {
    cursor: pointer;
    font-weight: normal;
  }

  .k-checks > input[type="checkbox"] {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    outline: none;
  }

  .k-checks > input[type="checkbox"]::before {
    display: inline-block;
    background: rgba(255, 255, 255, 0.5);
    content: " ";
    width: 16px;
    height: 16px;
    border: 1px solid #cccccc;
    border-radius: 1px;
    opacity: 1;
    margin-bottom: -3px;
  }

  .k-checks > input[type="checkbox"]:hover::before {
    border-color: #E37676;
  }

  .k-checks > input[type="checkbox"]:checked::before {
    background: #E37676;
    border-color: #E37676;
  }

  .k-checks > input[type="checkbox"]:checked::after {
    position: absolute;
    display: inline-block;
    content: "\f00c";
    font: normal normal normal 11px/1 FontAwesome;
    color: #ffffff;
    margin-left: -16px;
    width: 16px;
    text-align: center;
    line-height: 16px;
    margin-top: 2px;
  }

  .c-unactive {
    background: #cccccc !important;
  }

  @keyframes fa-blink {
    0% {
      opacity: 1;
    }
    25% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
    75% {
      opacity: 1;
    }
    100% {
      opacity: 0.25;
    }
  }

  .fixture-ref {
    color: #9c9e9f;
  }

  .number-in-league {
    font-weight: bolder;
    font-size: 20px;
  }

  .fa-blink {
    -webkit-animation: fa-blink .75s linear infinite;
    -moz-animation: fa-blink .75s linear infinite;
    -ms-animation: fa-blink .75s linear infinite;
    -o-animation: fa-blink .75s linear infinite;
    animation: fa-blink .75s linear infinite;
  }

  .text-primary {
    color: #28a745
  }

  .onoffswitch-inner:before {
    padding-left: 0px;
  }

</style>



// WEBPACK FOOTER //
// resources/assets/js/admin/pages/sports/fixture.vue